import { useEffect } from 'react'
import { useSystemActions } from '../../actions/systemActions'
import { useSystemStateHooks } from '../../state/hooks'

type Props = {
    userId: string
}

// The company users are only loaded for managers, so the user is loaded when missing: otherwise only its id could be shown
export const CompanyUserName = (props: Props) => {
    const { userId } = props

    const { companyUsers } = useSystemStateHooks()
    const systemActions = useSystemActions()

    const user = companyUsers.find(companyUser => companyUser.id === userId)

    useEffect(() => {
        if (!user) {
            systemActions().fetchCompanyUsers([userId])
        }
    }, [userId])

    return <>{user?.name || user?.email || userId}</>
}
